import { connect } from 'react-redux'
import {
  setAccordionExpandedNodeId,
  setAccordionExpandedNodeTitle,
  setUserRolesModalIsBasicMessage,
  setUserRolesModalIsOpen
} from 'redux/actions'
import SmartFcCrossReferenceLink from 'components/SmartFcCrossReferenceLink'

const mapStateToProps = state => ({
  expandedNodeId: state.accordion.expandedNodeId,
  sectionId: state.accordion.sectionId,
  group: state.accordion.group,
  isLimitedAccess: state.user.isLimitedAccess,
  flavour: state.layout.flavour,
  aol: state.aol.name
})

const mapDispatchToProps = dispatch => ({
  setAccordionExpandedNodeId: expandedNodeId => dispatch(setAccordionExpandedNodeId(expandedNodeId)),
  setAccordionExpandedNodeTitle: expandedNodeTitle => dispatch(setAccordionExpandedNodeTitle(expandedNodeTitle)),
  setUserRolesModalIsBasicMessage: isBasicMessage => dispatch(setUserRolesModalIsBasicMessage(isBasicMessage)),
  setUserRolesModalIsOpen: isOpen => dispatch(setUserRolesModalIsOpen(isOpen))
})

export default connect(mapStateToProps, mapDispatchToProps)(SmartFcCrossReferenceLink)
